/* @flow */

import { call, takeEvery, all } from 'redux-saga/effects';
import { workerRequest } from '../diplomatico/workers';
import type { Action } from '../diplomatico/types';

/**
 * Worker to handle the request of Achievement Cards
 */
 export const workerRequestChallengesOptions = ({ intelligence_id, language }) => ({
   requestParams: {
     endpoint: `/intelligences/${intelligence_id}/challenges?locale=${language}`,
     method: 'get',
     intelligence_id,
     language
   }
 });

export function* workerRequestChallenges(action: Action): any {
  let workerRequestGenerator = workerRequest(workerRequestChallengesOptions(action.payload));

  yield call(workerRequestGenerator, action);
}

export function* watchChallengesRequest(): any {
  yield all([
    takeEvery('REQUEST_CHALLENGES', workerRequestChallenges)
  ]);
}
